import React from 'react';
import Accordion from '../../common/accordion';

export default function DreamDrawAccordion({items}) {
  return <Accordion faqs={items} />;
}
